"use client";

import { useMarket } from "@app/_context";
import Items from "@components/Checkout/CheckoutItems";
import { useCartActions, useCartState } from "@context/cartContext";
import type { CartItem } from "@server/gql/graphql";

import { useCheckout, useCheckoutContext } from "./Checkout.hooks";

export default function CheckoutItems() {
  const { loading } = useCartState();
  const { locale } = useMarket().state.market;
  const { dictionary } = useCheckoutContext();
  const { data, isPending } = useCheckout();
  const { removeCartItem, updateCartItem } = useCartActions();

  const removeItem = (item: CartItem) => {
    void removeCartItem(item);
  };
  const updateItem = (item: CartItem) => {
    void updateCartItem(item);
  };

  if (!data?.items?.length) return null;

  const isLoading =
    loading.updateCartItem || loading.removeCartItem || isPending;

  return (
    <Items
      items={data.items.filter((item) => item.partNo !== "1000000")}
      dictionary={dictionary}
      removeItem={removeItem}
      updateItem={updateItem}
      locale={locale}
      loading={isLoading}
    />
  );
}
